import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';

/**
 * Shown when a free user has used their Vision slot — explicit upgrade moment, not a dead control.
 */
const VisionLimitCTA = ({ onUpgrade, compact = false }) => (
  <div
    className={
      compact
        ? 'rounded-lg border border-pine/30 bg-pine-tint/40 p-4'
        : 'rounded-xl border border-pine/30 bg-pine-tint/40 p-5 md:p-6'
    }
    role="region"
    aria-label="Vision limit reached"
  >
    <p className={`text-body text-ink ${compact ? 'mb-3' : 'mb-4'}`}>
      You&apos;ve used all 3 free Visions — upgrade to Pro for unlimited.
    </p>
    <button
      type="button"
      onClick={onUpgrade}
      className="btn-primary inline-flex items-center gap-2"
    >
      <SparklesIcon className="w-5 h-5" aria-hidden />
      Upgrade to Pro
    </button>
  </div>
);

export default VisionLimitCTA;
